import React from 'react'
import PropTypes from 'prop-types'
import { v4 as uuid4 } from 'uuid'
import { getText } from '../../../internal/TextLabels'
import {
  getLocalizedChatSupport,
  getLocalizedCreditSupport,
} from '../../../models/contactInformation'

import styles from './ChatOpeningHours.module.scss'

export const ChatOpeningHours = ({ countryCode }) => {
  const creditSupportOpeningHours = getLocalizedCreditSupport(countryCode)
  const chatOpeningHours = getLocalizedChatSupport(countryCode).openingHours

  const splitDateAndTime = dateAndTime => {
    return (
      <div>
        {dateAndTime.map(time => {
          const [days, hours] = time.split(' ')
          return (
            <div className={styles.spaceBetween} key={uuid4()}>
              <div>{days}</div>
              <div>{hours}</div>
            </div>
          )
        })}
      </div>
    )
  }

  return (
    <div className={styles.chatOpeningHours}>
      <div>
        <strong>{getText('chat.info.closed.creditFlowOpen')}</strong>
      </div>
      {splitDateAndTime(creditSupportOpeningHours.openingHours)}
      <br />
      <div>
        <strong>{getText('chat.info.closed.chatOpen')}</strong>
      </div>
      {splitDateAndTime(chatOpeningHours)}
      <br />
      <div>
        {getText('chat.info.closed.callOpen')}
        <span>{` ${creditSupportOpeningHours.phoneNumber}`}</span>
      </div>
    </div>
  )
}

ChatOpeningHours.propTypes = {
  countryCode: PropTypes.string.isRequired,
}
